import styled from 'styled-components';
import ProductDescription from 'ggApp/shared/screens/ProductDetailsPage/ProductDescription'

export const Description = styled(ProductDescription)`
    margin-bottom: ${({ theme }) => theme.spacers.XL};
    padding: 16px;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
    /* phones, mobile */
    ${(props) => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin-bottom: ${props.theme.spacers.XXL};
    `}
`;
